import {
  useLayoutEffect,
  useState,
  useEffect,
  useCallback,
  useRef,
} from "react";
import { Template } from "devextreme-react";
import DataGrid, {
  Column,
  Export,
  HeaderFilter,
  Pager,
  Paging,
  SearchPanel,
} from "devextreme-react/data-grid";
import {
  AssetSubStatus,
  DefaultDateFormat,
  IconWithTooltip,
} from "../../../helper/fixcode";
import { assetService } from "../../../apis/apiServices/Asset";
import { useNavigate } from "react-router-dom";
import "./../../../App.css";
import { useSelector } from "react-redux";
import moment from "moment";
import { Loader } from "../../Shared/PageLoader";

export default function AssetMaterialMovementRequestComponent(props) {
  const user = useSelector((state) => state.user.data);
  //console.log(props?.featurePermission);
  const navigate = useNavigate();

  const [state, setState] = useState({
    isCompleteLoading: false,
    loadingMessage: "",
  });

  const [
    assetMaterialMovementRequestDataSourceLst,
    setAssetMaterialMovementRequestDataSourceLst,
  ] = useState([]);
  const refDataGrid = useRef(null);

  useLayoutEffect(() => {
    document.querySelector("#pageTitle").innerHTML = `Movement Request`;
  }, []);

  let isUseEffectRendered = false;
  useEffect(() => {
    const controller = new AbortController();
    try {
      if (isUseEffectRendered) {
        return;
      }
      fetchApiOnPageLoad();
      return () => {
        controller.abort();
        isUseEffectRendered = true;
      };
    } catch (error) {
      console.log(error);
    }
  }, []);

  const fetchApiOnPageLoad = useCallback(async () => {
    try {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: true,
      }));
      await getAssetMaterialMovementList(0, user?.userId);
    } catch (error) {
      console.log(error);
    } finally {
      setState((prevState) => ({
        ...prevState,
        isCompleteLoading: false,
      }));
    }
  }, []);

  const getAssetMaterialMovementList = async (materialMrId, userId) => {
    try {
      //refDataGrid?.current?.instance?.beginCustomLoading();
      const response = await assetService.getAssetMaterialMovementList(
        materialMrId,
        userId
      );
      //console.log(response);
      setAssetMaterialMovementRequestDataSourceLst(
        response.data?.filter(
          (f) =>
            f.statusId !== Number(AssetSubStatus.AssetMaterialMovementApproved)
        ) ?? []
      );
    } catch (error) {
      console.log(error);
    } finally {
      //refDataGrid?.current?.instance?.endCustomLoading();
    }
  };

  return (
    <>
      <div className="content">
        <div className="card">
          <div className="card-body">
            <DataGrid
              ref={refDataGrid}
              keyExpr="materialMrId"
              dataSource={assetMaterialMovementRequestDataSourceLst}
              showColumnLines={false}
              showRowLines={true}
              showBorders={true}
              allowColumnResizing={false}
              allowColumnReordering={true}
              columnAutoWidth={true}
              onToolbarPreparing={(e) => {
                e.toolbarOptions.items.unshift(
                  {
                    location: "before",
                    template: "toolbarAddTemplate",
                  },
                  {
                    location: "before",
                    template: "toolbarRefreshTemplate",
                  }
                );
              }}
            >
              <Column
                dataField="materialMrId"
                // width={
                //   assetMaterialMovementRequestDataSourceLst?.filter(
                //     (f) =>
                //       f.statusId ===
                //       Number(AssetSubStatus.AssetMaterialMovementInDraftMode)
                //   ).length > 0
                //     ? 55
                //     : 25
                // }
                width={80}
                caption=""
                allowExporting={false}
                allowFiltering={false}
                allowSearch={false}
                allowSorting={false}
                cellRender={(cellData) => {
                  const idPrefix = `icon-${cellData?.data?.materialMrId}`;
                  return (
                    <>
                      <div style={{ display: "flex" }}>
                        {props?.featurePermission?.canView && (
                          <>
                            <span>
                              <IconWithTooltip
                                id={`${idPrefix}-view`}
                                className="iconify-size mr-1"
                                title="View asset material movement request"
                                tooltip="View asset material movement request"
                                icon="solar:document-text-outline"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  navigate("/ViewMaterialMovementRequest", {
                                    state: {
                                      materialMrId: cellData.data?.materialMrId,
                                      materialMovementNo:
                                        cellData.data?.materialMovementNo,
                                      formId: cellData.data?.formId,
                                      stateData: cellData.data,
                                      isReport: false,
                                      sourceUrl: "MaterialMovementRequest",
                                    },
                                  });
                                }}
                              />
                            </span>
                          </>
                        )}

                        {props?.featurePermission?.canEdit &&
                          cellData?.data?.actionAllowed &&
                          (cellData?.data?.statusId ===
                            Number(
                              AssetSubStatus.AssetMaterialMovementInDraftMode
                            ) ||
                            cellData?.data?.statusId ===
                              Number(
                                AssetSubStatus.AssetMaterialMovementPending
                              )) && (
                            <>
                              <span>
                                <IconWithTooltip
                                  id={`${idPrefix}-edit`}
                                  className="iconify-size mr-1"
                                  title="Edit asset material movement request"
                                  tooltip="Edit asset material movement request"
                                  icon="solar:pen-line-duotone"
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    navigate("/SaveMaterialMovementRequest", {
                                      state: {
                                        materialMrId:
                                          cellData.data?.materialMrId,
                                        materialMovementNo:
                                          cellData.data?.materialMovementNo,
                                        formId: cellData.data?.formId,
                                        statusId: cellData.data?.statusId,
                                        stateData: cellData.data,
                                        sourceUrl: "MaterialMovementRequest",
                                      },
                                    })
                                  }
                                />
                              </span>
                            </>
                          )}
                      </div>
                    </>
                  );
                }}
              />
              <Column
                dataField="assetRequestSubNo"
                caption="Asset Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="materialMovementNo"
                caption="Request No"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="assetDescription"
                caption="Asset Description"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="statusName"
                caption="Status"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                cellRender={(e) => {
                  let color = "#5f6460ff";
                  if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementInDraftMode
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementBackToDraft
                  )
                    color = "#ee0a0aff";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementApproved
                  )
                    color = "#4CAF50";
                  else if (
                    e.data?.statusId ===
                    AssetSubStatus.AssetMaterialMovementSentForApproval
                  )
                    color = "#FF9800";

                  var lastUpdatedDate = "";
                  if (!e?.data?.updatedOn) {
                    lastUpdatedDate = moment(e?.data?.createdOn)
                      .format(
                        DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                      )
                      .toString();
                  } else {
                    const parsedDate = new Date(e?.data?.updatedOn);
                    if (isNaN(parsedDate.getTime())) {
                      lastUpdatedDate = moment(e?.data?.updatedOn)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                        )
                        .toString();
                    }
                    const minDate = new Date("0001-01-01T00:00:00");
                    if (parsedDate.getTime() === minDate.getTime()) {
                      lastUpdatedDate = moment(e?.data?.createdOn)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                        )
                        .toString();
                    } else {
                      lastUpdatedDate = moment(e?.data?.updatedOn)
                        .format(
                          DefaultDateFormat.MomentDisplayDateTimeAMPMFullFormat
                        )
                        .toString();
                    }
                  }
                  return (
                    <div>
                      <span style={{ color }}>{e.data?.statusName}</span>
                      {/* <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {e.data?.currentWorlFlowUserId > 0
                          ? e.data?.currentWorlFlowUserFullName
                          : e.data?.fromName}
                      </div> */}
                      <br />
                      <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                        {lastUpdatedDate}
                      </div>
                    </div>
                  );
                }}
              />
              <Column
                dataField="requestedDate"
                caption="Request Date"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                dataType="date"
                format={DefaultDateFormat.GridDayMonthYearDateFormat}
              />
              <Column
                dataField="vendorName"
                caption="Vendor"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
              />
              <Column
                dataField="fromName"
                caption="From"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.fromName || ""} ${
                    data?.fromDepartmentName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.fromName ?? ""}</span>
                      {data?.data?.fromDepartmentName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.fromDepartmentName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toName"
                caption="To"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.toName || ""} ${
                    data?.toDepartmentName || ""
                  }`;
                }}
                allowSorting={true}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toName ?? ""}</span>
                      {data?.data?.toDepartmentName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toDepartmentName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="toProjectName"
                caption="Project"
                allowSearch={true}
                allowFiltering={false}
                allowSorting={true}
                calculateCellValue={(data) => {
                  return `${data?.toProjectName || ""} ${
                    data?.toLocationName || ""
                  }`;
                }}
                cellRender={(data) => {
                  return (
                    <>
                      <span>{data?.data?.toProjectName ?? ""}</span>
                      {data?.data?.toLocationName && (
                        <>
                          <br />
                          <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                            {data?.data?.toLocationName ?? ""}
                          </div>
                        </>
                      )}
                    </>
                  );
                }}
              />
              <Column
                dataField="createdDate"
                caption="Created On"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.createdDate || ""} ${
                    data?.createdByName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.createdDate) {
                    return (
                      <>
                        <span>
                          {moment(data?.data?.createdDate).format(
                            "DD/MM/YYYY"
                          ) +
                            " " +
                            moment(data?.data?.createdDate).format("LT") ?? ""}
                        </span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.createdByName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Column
                dataField="updatedByName"
                caption="Last Updated"
                allowSearch={true}
                allowFiltering={false}
                calculateCellValue={(data) => {
                  return `${data?.updatedByName || ""} ${
                    data?.toDepartmentName || ""
                  }`;
                }}
                cellRender={(data) => {
                  if (data?.data?.updatedByName) {
                    return (
                      <>
                        <span>{data?.data?.updatedByName ?? ""}</span>
                        <br />
                        <div style={{ color: "#b1b1b1", fontSize: "11px" }}>
                          {data?.data?.toDepartmentName ?? ""}
                        </div>
                      </>
                    );
                  } else {
                    return "";
                  }
                }}
              />
              <Template
                name="toolbarAddTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Add"
                        className="btn btn-primary btn-sm"
                        hidden={!props?.featurePermission?.canAdd}
                        onClick={() => {
                          navigate("/SaveMaterialMovementRequest");
                        }}
                      >
                        <i className="fas fa-plus"></i>
                        &nbsp;&nbsp;Add
                      </button>
                    </>
                  );
                }}
              />
              <Template
                name="toolbarRefreshTemplate"
                render={() => {
                  return (
                    <>
                      <button
                        style={{ cursor: "pointer" }}
                        type="button"
                        title="Refresh"
                        className="btn btn-outline-primary btn-sm"
                        onClick={async () => {
                          try {
                            setState((prevState) => ({
                              ...prevState,
                              isCompleteLoading: true,
                            }));
                            await getAssetMaterialMovementList(0, user?.userId);
                          } catch (error) {
                            console.log(error);
                          } finally {
                            setState((prevState) => ({
                              ...prevState,
                              isCompleteLoading: false,
                            }));
                          }
                        }}
                      >
                        <i className="fas fa-sync-alt"></i>
                        &nbsp;&nbsp;Refresh
                      </button>
                    </>
                  );
                }}
              />
              <HeaderFilter visible={false} />
              <SearchPanel
                visible={true}
                highlightCaseSensitive={true}
                width={240}
                placeholder="Search..."
              />
              <Paging defaultPageSize={10} />
              <Pager
                allowedPageSizes={[10, 15, 20, 50, 100]}
                showPageSizeSelector={true}
                showInfo={true}
                visible={true}
                showNavigationButtons={true}
              />
              <Export enabled={true} fileName="Material Movement Request" />
            </DataGrid>
          </div>
        </div>
      </div>

      {state.isCompleteLoading && (
        <Loader loadingMessage={state.loadingMessage} />
      )}
    </>
  );
}
